import { useContext } from 'react';

import { CustomerReportContext } from 'components/grace/Contexts';
import Modal from 'components/grace/Modal';
import OpenButton from 'components/grace/OpenButton';
import SurveyModal from 'components/grace/SurveyModal';
import useBrowserPathname from 'hooks/useBrowserPathname';
import useScreenSizeConstants from 'hooks/useScreenSizeConstants';
import { MODAL_TYPES } from 'lib/constants';

import HelpInterstitialModal from './HelpInterstitialModal';

const Grace = () => {
  const { customerReport, currentStage, currentModal, setCurrentModal } =
    useContext(CustomerReportContext);
  const pathname = useBrowserPathname();
  const { isUnderBp2 } = useScreenSizeConstants();

  const isOnBoxOrPickMeals = /\/signup\/box(\/|$)/.test(pathname) || pathname === '/pick-meals';
  const isOnFunnel = /\/signup(\/|$)/.test(pathname);
  const shouldHideModal =
    /\/account\/calendar\/.+/.test(pathname) || (isOnBoxOrPickMeals && isUnderBp2);

  const openAda = async () => {
    const onAdaDrawerToggle = isDrawerOpen => {
      if (isDrawerOpen) {
        setCurrentModal('');
      } else {
        setCurrentModal(MODAL_TYPES.help);
        window.adaEmbed.stop();
      }
    };
    await window.adaEmbed.start({ ...window.adaSettings, toggleCallback: onAdaDrawerToggle });
    await window.adaEmbed.reset({
      greeting: null,
      metaFields: {
        ...window.adaSettings.metaFields,
      },
    });
    await window.adaEmbed.toggle();
  };

  const renderModal = () => {
    switch (currentModal) {
      case MODAL_TYPES.grace:
        return customerReport && currentStage ? <Modal /> : isOnFunnel ? null : <OpenButton />;
      case MODAL_TYPES.survey:
        return <SurveyModal />;
      case MODAL_TYPES.ada:
        return <HelpInterstitialModal />;
      case MODAL_TYPES.cs:
        return <HelpInterstitialModal cs={true} />;
      case MODAL_TYPES.help:
        return isOnFunnel ? null : <OpenButton />;
      case MODAL_TYPES.actual_ada:
        openAda();
        break;
      default:
        return null;
    }
  };

  return <>{!shouldHideModal && renderModal()}</>;
};

export default Grace;
